import React from "react";
import { RefreshCw } from "lucide-react";

export const dashboardTableWrapClass =
  "dashboard-table-wrap dashboard-h-scroll-light overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm";

export const DashboardPageShell = ({
  eyebrow,
  title,
  description,
  icon: Icon,
  badges,
  tabs,
  children,
}) => (
  <div className="space-y-5">
    <section className="relative overflow-hidden rounded-2xl border border-[#0b1f3f]/10 bg-gradient-to-br from-[#0b1f3f] via-[#122a4d] to-[#1a3a6b] p-5 sm:p-6 text-white shadow-sm">
      <div
        className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#FE7E3F]/20 blur-3xl"
        aria-hidden
      />
      <div className="relative flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          {eyebrow ? (
            <p className="mb-2 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-white/60">
              {Icon ? <Icon size={14} className="text-[#FE7E3F]" /> : null}
              {eyebrow}
            </p>
          ) : null}
          {title ? <h1 className="text-2xl sm:text-3xl font-bold leading-tight">{title}</h1> : null}
          {description ? (
            <div className="mt-2 max-w-3xl text-sm sm:text-base text-white/75 leading-relaxed">{description}</div>
          ) : null}
        </div>
        {badges ? <div className="flex flex-wrap items-center gap-2 shrink-0">{badges}</div> : null}
      </div>
      {tabs ? <div className="relative mt-5">{tabs}</div> : null}
    </section>
    <div className="space-y-4">{children}</div>
  </div>
);

export const DashboardPanel = ({ title, description, actions, children, className = "" }) => (
  <div className={`rounded-2xl border border-slate-200 bg-white shadow-sm p-4 sm:p-5 ${className}`}>
    {title || description || actions ? (
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          {title ? <h2 className="text-lg font-semibold text-slate-900">{title}</h2> : null}
          {description ? <p className="mt-1 text-sm text-slate-500">{description}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div> : null}
      </div>
    ) : null}
    {children}
  </div>
);

export const DashboardTableWrap = ({ children, className = "" }) => (
  <div className={`${dashboardTableWrapClass} ${className}`}>{children}</div>
);

export const DashboardReloadButton = ({ onClick, loading, label = "Reload", className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={loading}
    className={`inline-flex items-center gap-1.5 rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 disabled:opacity-50 ${className}`}
  >
    <RefreshCw size={16} className={loading ? "animate-spin" : ""} />
    {label}
  </button>
);

export const DashboardEmptyState = ({ title, description }) => (
  <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-10 text-center">
    <p className="font-medium text-slate-700">{title}</p>
    {description ? <p className="mt-1 text-sm text-slate-500">{description}</p> : null}
  </div>
);

export const DashboardLoadingRow = ({ colSpan = 1, message = "Loading..." }) => (
  <tr>
    <td colSpan={colSpan} className="px-4 py-8 text-center text-sm text-slate-500">
      <RefreshCw size={18} className="mx-auto mb-2 animate-spin text-slate-400" />
      {message}
    </td>
  </tr>
);
